import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  styleUrl: './rich-text-editor.component.css'
})
export class RichTextEditorComponent {
  @Input({ required: true }) content = '';
  @Input() readOnly = false;

  @Output() contentChange = new EventEmitter<string>();

  onContentChanged = (data: any) => {
    this.contentChange.emit(this.content);
  };

  constructor() {}
}
